import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { MyprofileComponent } from './myprofile.component';
import { MyprofileRoutingModule } from './myprofile-routing.module';

import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { GtPlusModule } from '../../gt-plus/gt-plus.module';
import { CustomEvents } from '../../gt-plus/events';

@NgModule({
  imports: [
    FormsModule,
    CommonModule, ModalModule.forRoot(),
    MyprofileRoutingModule,
     BsDatepickerModule.forRoot(),
    GtPlusModule,
  ],
  declarations: [
    MyprofileComponent
  ],
  providers: [CustomEvents]

})
export class MyprofileModule { }